import { useSyncExternalStore } from 'react';
import './App.css';
import YearPicker from './components/YearPicker.js';
import ImgContainer from './components/ImgContainer.js';
import IndiaConstituencyMap from './components/IndiaConstituencyMap';
import ResultTable from './components/resultTable';
import { getPathname, subscribeToPathname } from './navigation';

function App() {
  const pathname = useSyncExternalStore(subscribeToPathname, getPathname);
  const constituencyMatch = pathname.match(/^\/constituency\/([^/]+)\/?$/i);
  const constituency = constituencyMatch?.[1]?.toLowerCase();

  return (
    <div className="App">
      <div className="site-banner">
        <img
          src="/img/india-elects-banner.png"
          alt="India Elects banner"
          className="site-banner__image"
        />
      </div>
      {constituency ? (
        <ResultTable constituency={constituency} />
      ) : (
        <div className="grid-row">
          <div className="grid-column">
            <YearPicker options={[2024,2019,2014,2009, 2004,1999,1998]} />
            <IndiaConstituencyMap />
          </div>
          <div className="grid-column">
            <YearPicker startYear={2000} endYear={new Date().getFullYear()} />
            <ImgContainer path="india-elects-banner.png" />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
